class PublicOrderController {
    static $inject = ["$q", "$location", "$sce", "stToast", "tpsrService", "reportService"];

    constructor($q, $location, $sce, stToast, tpsrService, reportService) {
        this.$q = $q;
        this.$location = $location;
        this.$sce = $sce;
        this.toast = stToast;
        this.tpsr = tpsrService;
        this.reportService = reportService;

        this.user = null;
        this.asUser = null;
        this.order = {
            lines: []
        }
    }

    $onInit() {
        return this._loadLink();
    }

    showApproveReject = order => {
        if (!this.asUser)
            return false;

        if (!this.asUser.is_approver)
            return false;

        if (!(order.order_status === 'PND' || order.order_status === 'REJ'))
            return false;

        if (this.asUser.user_id === order.create_user) // Admin cannot approve orders they create for other users.
            return false;

        return true;
    };


    approveClicked = order => {
        return this.tpsr.publicApproveOrder(order.order_id, this.asUser.user_id).then(result => {
            if (result.success) {
                this.toast.success("Order Approved", `Order approved.`)
                this._loadOrder(order.order_id);
            }
        });
    };

    rejectClicked = order => {
        return this.tpsr.publicRejectOrder(order.order_id, this.asUser.user_id).then(result => {
            if (result.success) {
                this.toast.success("Order Rejected", `Order rejected.`)
                this._loadOrder(order.order_id);
            }
        });
    };


    packingSlipClicked = shipment => {
        return this.reportService.getPackListRpt(shipment.PIMS_order_id);
    };

    downloadLabelClicked = order => {
        return this.reportService.getShippingLabel(order);
    };

    downloadLatestLabelClicked = () => {
        const returnOrder = this.returns.find(r => r.return_id === this.latestReturnId);
        console.log(this.returns);
        console.log(returnOrder);
        console.log(this.latestReturnId);
        return this.reportService.getShippingLabel(returnOrder);
    };

    

    _loadLink = () => {
        return this.tpsr.getPublicOrderLink(this.linkId).then(link => {
            return this.$q.all(
                this._loadOrder(link.order_id).then(o => this._loadUser(o.user_id)).then(u => this.user = u),
                this._loadUser(link.as_user_id).then(u => this.asUser = u)
            );
        });
    };

    _loadOrder = order_id => {
        return this.tpsr.getOrder(order_id).then(order => {
            this.order = order;
            return order;
        });
    };

    _loadUser = user_id => {
        return this.tpsr.getUser(user_id);
    };
}

angular
    .module("app")
    .component("publicOrder", { // public-order
        bindings: {
            linkId: "<"
        },
        templateUrl: "src/app/publicOrder/publicOrder.html",
        controller: PublicOrderController
    });
